// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector} from 'reselect';
import { OnlineCourse } from '../../../types/Model';
import { OnlineCourseInformationState } from '../../reducers/onlineCourseDataReducer';

import { RootState } from '../../rootReducer';

export const onlineCoursesRaw = (state: RootState):OnlineCourseInformationState => state.onlineCourseDataReducer

/**
 * when select specific onlineCourse, return the content
 */
export const makeOnlineCourseByIdSelector = (id: number): Selector<RootState, OnlineCourse> =>
  createSelector(
    onlineCoursesRaw,
    (onlineCoursesReducer) => onlineCoursesReducer.onlineCourses[id] || {} as OnlineCourse
  );

export const makeIsFetchingOnlineCourse = (): Selector<RootState, boolean> => {
  return createSelector(
    onlineCoursesRaw,
    (onlineCoursesReducer) => onlineCoursesReducer.isLoading
  );
};

export const makeOnlineCourseHasCourseByIdSelector = (id: number): Selector<RootState, boolean> =>
  createSelector(
    makeOnlineCourseByIdSelector(id),
    (onlineCourse) => onlineCourse.hasCourse || false
  );

export const makeOnlineCourseHasSampleByIdSelector = (id: number): Selector<RootState, boolean> =>
  createSelector(
    makeOnlineCourseByIdSelector(id),
    (onlineCourse) => onlineCourse.hasSample || false
  );

export const makeError= (): Selector<RootState, Error | undefined> => {
  return createSelector(
    onlineCoursesRaw,
    (onlineCoursesReducer) => onlineCoursesReducer.error
  );
};
